import React, { Component } from 'react';
import { do_action } from '../../actions'
import { instanceOf } from 'prop-types'
import { Cookies } from 'react-cookie'
import {setVendor} from '../../actions/index';

const cookies = new Cookies();

class Signin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            warningMessage: ''
        }
    }

    componentWillMount() {
        let {history} = this.props
        const token = cookies.get('vendor');
        if (token) {
            return history.push('/quotes');
        }
    }

    componentDidMount() {
        this.refs.email.focus();
    }

    changeInput = (property, event) => {
        this.setState({ [property]: event.target.value });
    }

    signIn = (e) => {
        e.preventDefault();
        let {dispatch, history} = this.props;
        let { email, password } = this.state;
        if (!email) {
            return this.setState({ warningMessage: 'Please enter email' });
        }
        if (!password) {
            return this.setState({ warningMessage: 'Please enter your password' });
        }
        do_action('vendor_sign_in', { email, password })
            .then(data => {
                if (data.signal) {
                    cookies.set('vendor', data.data.token, { path: '/', maxAge: 96969696 });
                    history.push('/quotes');
                } else {
                    this.setState({ warningMessage: data.message })
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ warningMessage: 'Something went wrong!' });
            });
    }

    render() {
        return (
            <div className="signin-ruhu">
                <div className="cont3nt-body">
                    <div className="title">
                        <div className="text">Sign In</div>
                    </div>
                    <form onSubmit={this.signIn.bind(this)}>
                        <div className="content">
                            <div className="form-group">
                                <input type="text" ref="email" value={this.state.email} onChange={this.changeInput.bind(this, 'email')} className="form-control input-mixx input-mixx-email" placeholder="Email"/>
                            </div>
                            <div className="form-group">
                                <input type="password" value={this.state.password} onChange={this.changeInput.bind(this, 'password')} className="form-control input-mixx input-mixx-password" placeholder="Password"/>
                            </div>
                            <p className="text-danger">{this.state.warningMessage}</p>
                            <div className="form-group">
                            <button type="submit" className="bg-blue action" style={{width: '100%'}}>Sign In</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default Signin;